import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Tab, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ProjectManager from '../components/admin/ProjectManager';
import StaffManager from '../components/admin/StaffManager';
import axios from 'axios';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('projects');
  const [adminInfo, setAdminInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAdminInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          window.location.href = '/login';
          return;
        }

        const apiUrl = process.env.REACT_APP_API_URL || 'https://cogeis.onrender.com';
        const response = await axios.get(`${apiUrl}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAdminInfo(response.data.data);
      } catch (err) {
        if (err.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.href = '/login';
        } else {
          setError('Errore nel caricamento dei dati amministratore');
        }
      }
    };

    fetchAdminInfo();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <Container fluid className="mt-5">
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1>Area Amministratore</h1>
              {adminInfo && (
                <p className="text-muted">
                  Benvenuto, {adminInfo.nome} ({adminInfo.ruolo})
                </p>
              )}
            </div>
            <div className="d-flex gap-2">
              <Link to="/" className="btn btn-outline-secondary">
                <i className="fas fa-home me-2"></i>
                Torna alla Home
              </Link>
              <button 
                className="btn btn-outline-danger"
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt me-2"></i>
                Logout
              </button>
            </div>
          </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <Row>
                <Col md={3}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="projects" className="mb-2">
                        <i className="fas fa-project-diagram me-2"></i>
                        Gestione Progetti
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="staff" className="mb-2">
                        <i className="fas fa-users me-2"></i>
                        Gestione Staff
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col md={9}>
                  <Tab.Content>
                    <Tab.Pane eventKey="projects">
                      <ProjectManager />
                    </Tab.Pane>
                    <Tab.Pane eventKey="staff">
                      <StaffManager />
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
  );
};

export default Admin; 